import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// ✅ Siempre manda el token si existe
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Si backend responde 401/403 => limpiar token y mandar a /login
let isRedirecting = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if ((status === 401 || status === 403) && !isRedirecting) {
      isRedirecting = true;

      // Limpia token para que PrivateRoute saque al usuario
      localStorage.removeItem("token");

      // Evitar loop si ya estás en login
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      } else {
        isRedirecting = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
